var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AndOrOperator, CriteriaGroupType, CriteriaTerminalType, } from '../../../types';
export function dtoToConditionCriteria(filter, feeFineTypes, locations, stripes, intl) {
    var _a, _b, _c, _d;
    if (filter.operation === AndOrOperator.AND) {
        return {
            type: CriteriaGroupType.ALL_OF,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            criteria: (_b = (_a = filter.criteria) === null || _a === void 0 ? void 0 : _a.map(function (criteria) { return dtoToCriteria(criteria, feeFineTypes, locations, stripes, intl); })) !== null && _b !== void 0 ? _b : [],
        };
    }
    else {
        return {
            type: CriteriaGroupType.ANY_OF,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            criteria: (_d = (_c = filter.criteria) === null || _c === void 0 ? void 0 : _c.map(function (criteria) { return dtoToCriteria(criteria, feeFineTypes, locations, stripes, intl); })) !== null && _d !== void 0 ? _d : [],
        };
    }
}
export function dtoToNegationCriteria(filter, feeFineTypes, locations, stripes, intl) {
    var _a, _b, _c, _d;
    // NOR gets displayed as "None of" in the UI, so we flatten the inner OR
    if (((_a = filter.criteria) === null || _a === void 0 ? void 0 : _a.type) === 'Condition' && ((_b = filter.criteria) === null || _b === void 0 ? void 0 : _b.operation) === AndOrOperator.OR) {
        return {
            type: CriteriaGroupType.NONE_OF,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            criteria: (_d = (_c = filter.criteria.criteria) === null || _c === void 0 ? void 0 : _c.map(function (criteria) { return dtoToCriteria(criteria, feeFineTypes, locations, stripes, intl); })) !== null && _d !== void 0 ? _d : [],
        };
    }
    // otherwise, just negate the single inner criteria
    return {
        type: CriteriaGroupType.NONE_OF,
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        criteria: filter.criteria ? [dtoToCriteria(filter.criteria, feeFineTypes, locations, stripes, intl)] : [],
    };
}
export function getFeeFineOwnerId(feeFineTypeId, feeFineTypes) {
    var feeFineType = feeFineTypes.find(function (type) { return type.id === feeFineTypeId; });
    if (feeFineType === null || feeFineType === void 0 ? void 0 : feeFineType.ownerId) {
        return feeFineType.ownerId;
    }
    return 'automatic';
}
export function getLocationProperties(locationId, locations) {
    var location = locations.find(function (loc) { return loc.id === locationId; });
    if (!location) {
        return {};
    }
    return {
        institutionId: location.institutionId,
        campusId: location.campusId,
        libraryId: location.libraryId,
    };
}
// inverse of ../to/criteriaToFilterDto
export default function dtoToCriteria(filter, feeFineTypes, locations, stripes, intl) {
    var _a, _b, _c, _d, _e, _f, _g;
    switch (filter.type) {
        case CriteriaTerminalType.AGE:
            return {
                type: CriteriaTerminalType.AGE,
                operator: filter.condition,
                numDays: (_b = (_a = filter.numDays) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
            };
        case CriteriaTerminalType.AMOUNT:
            return {
                type: CriteriaTerminalType.AMOUNT,
                operator: filter.condition,
                amountCurrency: intl.formatNumber(((_c = filter.amount) !== null && _c !== void 0 ? _c : 0) / 100, { style: 'currency', currency: stripes.currency }),
            };
        case CriteriaTerminalType.FEE_FINE_OWNER:
            return {
                type: CriteriaTerminalType.FEE_FINE_OWNER,
                feeFineOwnerId: filter.feeFineOwner,
            };
        case CriteriaTerminalType.FEE_FINE_TYPE:
            return {
                type: CriteriaTerminalType.FEE_FINE_TYPE,
                feeFineTypeId: (_d = filter.feeFineTypeId) !== null && _d !== void 0 ? _d : '',
                feeFineOwnerId: getFeeFineOwnerId((_e = filter.feeFineTypeId) !== null && _e !== void 0 ? _e : '', feeFineTypes),
            };
        case CriteriaTerminalType.LOCATION:
            return __assign({ type: CriteriaTerminalType.LOCATION, locationId: (_f = filter.locationId) !== null && _f !== void 0 ? _f : '' }, getLocationProperties((_g = filter.locationId) !== null && _g !== void 0 ? _g : '', locations));
        case CriteriaTerminalType.PATRON_GROUP:
            return {
                type: CriteriaTerminalType.PATRON_GROUP,
                patronGroupId: filter.patronGroupId,
            };
        case CriteriaTerminalType.SERVICE_POINT:
            return {
                type: CriteriaTerminalType.SERVICE_POINT,
                servicePointId: filter.servicePointId,
            };
        case 'Condition':
            return dtoToConditionCriteria(filter, feeFineTypes, locations, stripes, intl);
        case 'Negation':
            return dtoToNegationCriteria(filter, feeFineTypes, locations, stripes, intl);
        case CriteriaTerminalType.PASS:
        default:
            return {
                type: CriteriaTerminalType.PASS,
            };
    }
}
